<template>
  <aside class="sidebar" ref="sidebarEl">
    <div class="section-title">
      Настройки профиля
    </div>

    <ul class="menu">
      <li
        v-for="item in items"
        :key="item.key"
        :class="{ active: item.key === activeItem }"
        @click="handleItemChange(item.key)"
      >
      <span class="menu-icon">

        <img
          :src="item.icon"
          :alt="item.label"
          class="menu-icon-image"
        />
        </span>

        <span class="menu-label">
          {{ item.label }}
        </span>

        <span
          class="chevron"
          :class="{ visible: item.key === activeItem }"
        >
          ›
        </span>
      </li>
    </ul>
  </aside>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { ref, nextTick } from 'vue';

import ssGeneral from "../assets/sidebar/ss-general.png";
import ssSkills from "../assets/sidebar/ss-skills.png";
import ssCompany from "../assets/sidebar/ss-company.png";
import ssResume from "../assets/sidebar/ss-resume.png";
import ssSocial from "../assets/sidebar/ss-social.png";
import ssProfessional from "../assets/sidebar/ss-professional.png";
import ssPremium from "../assets/sidebar/ss-premium.png";
import ssOther from "../assets/sidebar/ss-other.png";
import ssAccount from "../assets/sidebar/ss-account.png";
import ssContent from "../assets/sidebar/ss-content.png";

const sidebarEl = ref(null);

const handleItemChange = (key) => {
  emit("change", key);

  nextTick(() => {
    if (sidebarEl.value) {
      console.log("📏 SIDEBAR WIDTH:", sidebarEl.value.offsetWidth);
      console.log("📐 SIDEBAR HEIGHT:", sidebarEl.value.offsetHeight);
    }
  });
};

const props = defineProps({
  activeItem: String,
});

const emit = defineEmits(['change']);

const items = [
  { key: "general", label: "Общее", icon: ssGeneral },
  { key: "skills", label: "Проф скиллы", icon: ssSkills },
  { key: "company", label: "Компания", icon: ssCompany },

  {
    key: "employer-content",
    label: "Размещение контента",
    icon: ssContent
  },

  { key: "resume", label: "Резюме", icon: ssResume },
  { key: "social", label: "Социальные сети", icon: ssSocial },
  {
    key: "professional",
    label: "Профессиональные ссылки",
    icon: ssProfessional
  },
  { key: "premium", label: "Премиум", icon: ssPremium },
  { key: "other", label: "Прочее", icon: ssOther },
  { key: "account", label: "Аккаунт", icon: ssAccount }
];

</script>

<style scoped>

.sidebar {
  width: 240px;
  min-width: 240px;
  max-width: 240px;

  padding: 18px;

  flex-shrink: 0;

  background: transparent;
  border: none;
  box-shadow: none;
}

.section-title {
  margin: 4px 10px 18px;

  font-family: "Eastman-Bold", sans-serif;
  font-size: 13px;
  line-height: 1.2;
  letter-spacing: -0.15px;

  color: #7b7b82;
}

.menu {
  list-style: none;
  padding: 0;
  margin: 0;

  display: flex;
  flex-direction: column;
  gap: 5px;
}

.menu li {
  position: relative;

  min-height: 44px;

  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) 16px;
  align-items: center;
  column-gap: 10px;

  padding: 8px 11px;

  border-radius: 15px;

  color: #202124;
  cursor: pointer;

  transition:
    background-color 180ms ease,
    color 180ms ease,
    transform 180ms ease,
    box-shadow 180ms ease;
}

.menu li::before {
  content: "";

  position: absolute;

  left: 0;
  top: 50%;

  width: 3px;
  height: 0;

  border-radius: 999px;
  background: #2887f7;

  transform: translateY(-50%);

  transition:
    height 180ms ease,
    opacity 180ms ease;

  opacity: 0;
}

.menu li:hover {
  background: rgba(40, 135, 247, 0.07);
  transform: translateX(2px);
}

.menu li.active {
  background:
    linear-gradient(
      135deg,
      rgba(40, 135, 247, 0.16),
      rgba(40, 135, 247, 0.08)
    );

  color: #176ed8;

  box-shadow:
    inset 0 0 0 1px rgba(40, 135, 247, 0.1),
    0 8px 20px rgba(40, 135, 247, 0.08);
}

.menu li.active::before {
  height: 24px;
  opacity: 1;
}

.menu-icon {
  width: 28px;
  height: 28px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  border-radius: 9px;

  background: rgba(17, 17, 17, 0.045);

  font-family: "Eastman-Bold", sans-serif;
  font-size: 13px;
  line-height: 1;

  color: #6f7178;

  transition:
    background-color 180ms ease,
    color 180ms ease,
    transform 180ms ease;
}

.menu li:hover .menu-icon {
  transform: scale(1.04);
}

.menu li.active .menu-icon {
  background: #2887f7;
  color: #ffffff;

  box-shadow:
    0 6px 14px rgba(40, 135, 247, 0.24);
}

.menu-label {
  min-width: 0;

  font-size: 13px;
  line-height: 1.2;
  letter-spacing: -0.1px;

  white-space: normal;
  word-break: break-word;
}

.chevron {
  width: 16px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  font-size: 19px;
  line-height: 1;

  color: #2887f7;

  opacity: 0;
  transform: translateX(-5px);

  transition:
    opacity 160ms ease,
    transform 160ms ease;
}

.chevron.visible {
  opacity: 1;
  transform: translateX(0);
}

/* Тёмная тема */

:global(html[data-theme="dark"]) .sidebar {
  border-color: rgba(255, 255, 255, 0.06);

  background:
    linear-gradient(
      145deg,
      rgba(38, 39, 43, 0.98),
      rgba(30, 31, 35, 0.96)
    );

  box-shadow:
    0 20px 55px rgba(0, 0, 0, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.035);
}

:global(html[data-theme="dark"]) .section-title {
  color: #8f929a;
}

:global(html[data-theme="dark"]) .menu li {
  color: #f1f1f3;
}

:global(html[data-theme="dark"]) .menu li:hover {
  background: rgba(255, 255, 255, 0.055);
}

:global(html[data-theme="dark"]) .menu li.active {
  background:
    linear-gradient(
      135deg,
      rgba(40, 135, 247, 0.24),
      rgba(40, 135, 247, 0.11)
    );

  color: #9bc4ff;

  box-shadow:
    inset 0 0 0 1px rgba(40, 135, 247, 0.16),
    0 10px 24px rgba(0, 0, 0, 0.16);
}

:global(html[data-theme="dark"]) .menu-icon {
  background: rgba(255, 255, 255, 0.06);
  color: #a7a9af;
}

:global(html[data-theme="dark"]) .menu li.active .menu-icon {
  background: #2887f7;
  color: #ffffff;
}

:global(html[data-theme="dark"]) .chevron {
  color: #83b7ff;
}

/* Небольшие экраны */

@media (max-width: 1100px) {
  .sidebar {
    width: 210px;
    min-width: 210px;
    max-width: 210px;

    padding: 14px;
    border-radius: 20px;
  }

  .menu li {
    min-height: 42px;
    grid-template-columns: 26px minmax(0, 1fr) 14px;
    column-gap: 8px;
    padding: 7px 9px;
  }

  .menu-icon {
    width: 26px;
    height: 26px;
  }

  .menu-label {
    font-size: 12px;
  }
}

[data-theme="dark"] .menu li {
  color: rgba(255, 255, 255, 0.88);
}

[data-theme="dark"] .section-title {
  color: rgba(255, 255, 255, 0.55);
}

[data-theme="dark"] .menu-icon {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.75);
}

[data-theme="dark"] .menu li.active {
  color: #ffffff;
}

[data-theme="dark"] .chevron {
  color: #7bb2ff;
}

.menu-icon-image {
  width: 16px;
  height: 16px;
  object-fit: contain;
  display: block;
}

.menu li.active .menu-icon-image {
  filter: brightness(0) invert(1);
}

</style>